import { useReducer } from 'react';

const initialState = {
  isOpen: false,
  commentText: '',
  targetEncounterId: 0,
  commentId: 0,
  commentType: 'CoreEncounter',
  isActive: true,
  canBeDeleted: false,
  canBeEdited: false,
  isHoldComment: false
};

const ACTION_TYPES = {
  OPEN_ADD_COMMENT_DIALOG: 'OPEN_ADD_COMMENT_DIALOG',
  CLOSE_ADD_COMMENT_DIALOG: 'CLOSE_ADD_COMMENT_DIALOG'
};

const ACTIONS = {
  openAddCommentDialog: (targetEncounterId, commentId, sourceText, commentType, editMode, canBeDeleted, canBeEdited, isHoldComment, isActive) => ({
    type: ACTION_TYPES.OPEN_ADD_COMMENT_DIALOG,
    payload: {
      targetEncounterId,
      commentId,
      sourceText,
      commentType,
      editMode,
      canBeDeleted,
      canBeEdited,
      isHoldComment,
      isActive
    }
  }),
  closeAddCommentDialog: () => ({
    type: ACTION_TYPES.CLOSE_ADD_COMMENT_DIALOG
  })
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.OPEN_ADD_COMMENT_DIALOG: {
      const { payload: { targetEncounterId, commentId, sourceText, commentType, editMode, canBeDeleted, canBeEdited, isHoldComment, isActive } } = action;
      return { ...state, isOpen: true, targetEncounterId, commentId, commentText: sourceText, commentType, editMode: editMode, canBeDeleted: canBeDeleted, canBeEdited: canBeEdited, isHoldComment: isHoldComment, isActive: isActive };
    }

    case ACTION_TYPES.CLOSE_ADD_COMMENT_DIALOG: {
      return { ...state, isOpen: false, targetEncounterId: 0, commentText: '', commentId: 0, isActive: false, canBeDeleted: false, canBeEdited: false, isHoldComment: false, isActive: true };
    }

    default: {
      throw Error('useAddCommentDialog reducer should never hit default case');
    }
  }
};

const useAddCommentDialog = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const open = (id, commentId, sourceText, commentType, editMode, canBeDeleted, canBeEdited, isHoldComment, isActive) => dispatch(ACTIONS.openAddCommentDialog(id, commentId, sourceText, commentType, editMode, canBeDeleted, canBeEdited, isHoldComment, isActive));
  const close = () => dispatch(ACTIONS.closeAddCommentDialog());

  const boundActions = {
    open,
    close
  };

  return [state, boundActions];
};

export default useAddCommentDialog;
